(function () {
  'use strict';
  var key = 'l2c_native_login_return';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function storefrontPath(value) {
    if (!value) return '';
    try {
      var url = new URL(value, location.origin);
      if (url.origin !== location.origin || /\/(account|challenge|customer_authentication)(\/|$)/.test(url.pathname)) return '';
      return url.pathname + url.search + url.hash;
    } catch (error) { return ''; }
  }

  function destination() {
    var current = storefrontPath(location.href);
    if (current) return current;
    var requested = storefrontPath(new URLSearchParams(location.search).get('return_to'));
    var stored = '';
    try { stored = storefrontPath(sessionStorage.getItem(key)); } catch (error) {}
    return requested || stored || storefrontPath(document.referrer) || root;
  }

  function update(form) {
    // The OTP app manages its own authentication and redirect fields.
    if (form.id === 'sotp-form' || !form.querySelector('[name="form_type"][value="customer_login"]')) return;
    var field = form.querySelector('[name="return_to"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      form.appendChild(field);
    }
    field.value = destination();
    try { sessionStorage.setItem(key, field.value); } catch (error) {}
  }

  var current = storefrontPath(location.href);
  if (current) {
    try { sessionStorage.setItem(key, current); } catch (error) {}
  }
  document.querySelectorAll('form').forEach(update);
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, location.origin);
    var current = storefrontPath(location.href);
    if (!current || url.origin !== location.origin || !/\/account\/login\/?$/.test(url.pathname)) return;
    try { sessionStorage.setItem(key, current); } catch (error) {}
    url.searchParams.set('return_to', current);
    link.href = url.href;
  }, true);
  document.addEventListener('submit', function (event) { update(event.target); }, true);
  // Login drawers can be loaded after the page has finished loading.
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('form')) update(node);
        node.querySelectorAll('form').forEach(update);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
